export const ENTRY_AVATAR_SIZE = 40;
export const ACTOR_AVATAR_SIZE = 24;
